export const colors = {
  1: '#00ccbe',
  2: '#00c176',
  3: '#ffe461',
  4: '#fab243',
  5: '#fa7a32',
  6: '#db3026',
}
